module.exports = __webpack_public_path__ + "img/kaokutoukai_hanran.a527a110.png";